import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {BaseModel, WarningBaseModel} from "../models/BaseModel";
import {Organization} from "../models/Organization/organizationResponse";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private http: HttpClient) {
  }

  private apiUrl = environment.apiConfig.uri + '/api/organization';

  register(formData: any): Observable<BaseModel<any>> {
    return this.http.post<BaseModel<Organization>>(`${this.apiUrl}/register`, formData);
  }

  submit(formData: any): Observable<WarningBaseModel<any>> {
    return this.http.post<WarningBaseModel<string>>(`${this.apiUrl}/register`, formData);
  }

  update(formData: any): Observable<BaseModel<any>> {
    return this.http.post<BaseModel<Organization>>(`${this.apiUrl}/update`, formData);
  }

  addContact(formData: any): Observable<BaseModel<any>> {
    return this.http.post<BaseModel<Organization>>(`${this.apiUrl}/addcontact`, formData);
  }

  addPaymentInfo(formData: any): Observable<BaseModel<any>> {
    return this.http.post<BaseModel<Organization>>(`${this.apiUrl}/addpayment`, formData);
  }

  getOrganizationInfo(): Observable<BaseModel<Organization>> {
    return this.http.get<BaseModel<Organization>>(`${this.apiUrl}/getinfo`);
  }
}
